import { render, staticRenderFns } from "./InnovationContest.vue?vue&type=template&id=65271f54&scoped=true&"
import script from "./InnovationContest.vue?vue&type=script&lang=js&"
export * from "./InnovationContest.vue?vue&type=script&lang=js&"
import style0 from "./InnovationContest.vue?vue&type=style&index=0&id=65271f54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65271f54",
  null
  
)

export default component.exports